import React from "react";

interface Props {
  className?: string;
  size?: number;
}

const TrendingDown: React.FC<Props> = ({ className, size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.75313 3.91836L1.79688 4.87461L7.06563 10.1434L9.91563 7.29336L13.8906 11.2496H11.6969V12.5996H16.1969V8.09961H14.8469V10.2934L9.91563 5.38086L7.06563 8.23086L2.75313 3.91836Z"
        fill="var(--iconDanger)"
      />
    </svg>
  );
};

export default TrendingDown;
